"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddWorkspaceCard = void 0;
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const react_1 = __importDefault(require("react"));
require("../workspace-select-card/style.scss");
require("./add-workspace-card.scss");
/** Toned-down last card of the workspace selection: creates a new workspace instead of entering one. */
const AddWorkspaceCard = ({ onClick }) => (react_1.default.createElement("div", { "data-testid": 'workspace-select-card-add', className: 'ds-ws-card ds-ws-card-add' },
    react_1.default.createElement("div", { className: 'ds-ws-card-top' },
        react_1.default.createElement("div", { className: 'ds-ws-card-avatar' },
            react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.plus })),
        react_1.default.createElement("div", { className: 'ds-ws-card-name' }, (0, util_1.t)('ORG_SP_WORKSPACES_WORKSPACE_ADD_NEW'))),
    react_1.default.createElement(_ui_1.Button, { onClick: onClick, size: _ui_1.Button.SIZES.LARGE, color: _ui_1.Button.COLORS.DEFAULT, label: (0, util_1.t)('ADD'), bold: true })));
exports.AddWorkspaceCard = AddWorkspaceCard;
